export default __webpack_public_path__ + "invalid-records-dark-icon.svg";